import { IOffStreetParking } from "@/types";
import { ParkingLayout } from "@/types/gql/graphql";

export const PARKING_LAYOUT_OPTIONS = [
  { value: ParkingLayout.Surface, label: "Surface" },
  { value: ParkingLayout.Underground, label: "Underground" },
  { value: ParkingLayout.MultiStorey, label: "Multi-storey" },
  { value: ParkingLayout.Automated, label: "Automated" },
];

export const initOffStreetParking: IOffStreetParking = {
  name: "",
  location: {
    type: "Point",
    coordinates: [],
  },
  address: "",
  cityId: "",
  externalId: "",
  totalPlaces: 0,
  pricePerHour: 0,
  maxHeight: 0,
  levels: 0,
  otherAdresses: [],
  options: {
    evChargers: 0,
    disabledPlaces: 0,
    bicyclePlaces: 0,
    motorcyclePlaces: 0,
  },
  openingHours: [],
};

export const ICON_MAPPING = {
  marker: { x: 0, y: 0, width: 60, height: 60 },
};

export const MARKER_MAPPING = {
  marker: { x: 0, y: 0, width: 60, height: 70 },
};

export enum OffStreetParkingModalState {
  SHOW = "SHOW",
  DEACTIVATE = "DEACTIVATE",
  MINIMIZE = "MINIMIZE",
}
